module.exports = __webpack_public_path__ + "assets/fdcc64d69128b4f4e731f060336783e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook.png
// module id = 391
// module chunks = 1